import React, { ChangeEvent, useEffect, useState } from 'react'
import Input from '../../components/UI/Input'
import { IConfigPageProps } from './types'
import { Divider } from 'antd'
import Button from '../../components/UI/Button'
import { refreshCompanyCache } from '../../services/config'
import { sendSystemLog, useAuth } from '../../context/AuthProvider/useAuth'

export const switchOptions = {
  check: 'true',
  uncheck: 'false',
}

function Portal(props: IConfigPageProps) {
  const {canEdit} = useAuth()
  const log = {
    log_type: 'visited',
    log_object: 'system configs',
    object_name: 'portal'
  }

  useEffect(() => {
    sendSystemLog(log);
  }, [])

  const reloadCompanyCache = async () => {
    await refreshCompanyCache()
  }

  return (
    <>
      <Input
        label="Session timeout in minutes (default is 5 minutes, invalid values revert to default)"
        onChange={(e: any) => props.setConfig(e.target.value, 'SESSION_TIMEOUT_IN_MINUTES')}
        value={props.config.SESSION_TIMEOUT_IN_MINUTES}
        type="number"
        disabled={!canEdit}
      />
      <Divider />
      <div className="config-messaging__row">
        <div className="config-messaging__row__button-placeholder">Reload the in-memory location cache. Should be used on exceptional cases when a company is changed directly on the database.</div>
        <Button type="primary" onClick={reloadCompanyCache} style={{height: 30}} disabled={!canEdit}>
          Reload Company Cache
        </Button>
      </div>
    </>
  )
}

export default Portal